import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import { PRODUCT_FEED_TYPE } from '@src/quince-site-common/src/services/productFeedService/productFeedService.types'
import ProductListTwo from '@src/SectionRenderer/sections/productListTwo'
import { useTranslation } from 'next-i18next'

const NewSiteProductListSection = () => {
  const { t } = useTranslation('common')
  return (
    <ProductListTwo
      sectionConfig={{
        // @i18n-ignore
        typename: 'CustomSection',
        // @i18n-ignore
        id: '9df76955-f8c1-57de-bc65-d5e89a22d299',
        displayTitle: '',
        buttons: [],
        products: [],
        richTexts: [
          {
            // @i18n-ignore
            id: 'c9653082-6546-59a0-bc0d-125eea46844f',
            raw: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: t('you_may_also_like'),
                      // @i18n-ignore
                      nodeType: 'text',
                    },
                  ],

                  // @i18n-ignore
                  nodeType: 'paragraph',
                },
              ],

              // @i18n-ignore
              nodeType: 'document',
            },
            mobileClassNames: ['font-size--30'],
            desktopClassNames: [],
            commonClassNames: ['color--black', 'font-family--ivy-headline', 'font-size--56', 'text-align--center'],
            dynamicValueClassesMobile: ['margin-bottom--41'],
            baseDynamicValueClasses: ['margin-bottom--60'],
          },
        ],
        sectionType: CUSTOM_SECTION_TYPE.PRODUCT_LIST_TWO,
        subSections: [],
        // @i18n-ignore
        title: 'Account Page Best Sellers',
        classNames: ['background-color--offWhite'],
        influencers: [],
        layoutType: LAYOUT_TYPES.DEFAULT,
        // @i18n-ignore
        position: 'DEFAULT',
        baseDynamicClasses: null,
        mobileDynamicClassesOverrides: null,
        navigationType: null,
        classNamesMobileOverrides: [],
        productFeedType: PRODUCT_FEED_TYPE.CUSTOMER_TOP_PRODUCTS,
        productFeedLimit: 4,
      }}
    />
  )
}

export default NewSiteProductListSection
